// API
import ApiBase from '../ApiBase';
import { farmSettingsUrl } from '../apiEndpoints';

// Interfaces
import {
    IFarmSettings,
    IFarmSettingsUpdatePayload,
    IStoreFarmSettingsPayload,
} from '../../interfaces/IFarmSettings';

class FarmSettingsApi extends ApiBase {
    getFarmSettings(farmId: string) {
        return this.get<IFarmSettings>(`${farmSettingsUrl}/${farmId}`);
    }

    storeFarmSettings(farmSettings: IStoreFarmSettingsPayload) {
        return this.post<IFarmSettings>(`${farmSettingsUrl}/StoreFarmSettings`, farmSettings);
    }

    updateFarmSettings(farmSettings: IFarmSettingsUpdatePayload) {
        return this.patch<IFarmSettings>(`${farmSettingsUrl}/UpdateFarmSettings`, farmSettings);
    }
}

export default new FarmSettingsApi();
